import { useAxiosPost } from "../../infrastructure/http";
import {LineItemReceivedEvent} from "./Models/LineItemReceivedEvent";

/**
 * This endpoint accepts a single line item from a Receive
 * It takes care of updating / inserting the line item on the Receive, as well as updating
 * the Receive totals (for manual receiving). 
 * */
export function usePostLineItemReceived() {
    return useAxiosPost<LineItemReceivedEvent, void>("/line-item/received", true);
}